import React from 'react';
import { Link2, GitBranch, Clock, CheckCircle, AlertCircle } from 'lucide-react';
import { Task } from '../../lib/db';

interface TaskDependencyBadgeProps {
  task: Task;
  blockingTasks?: string[];
}

function TaskDependencyBadge({ task, blockingTasks }: TaskDependencyBadgeProps) {
  if (!task.depends_on || task.depends_on.length === 0) {
    return null;
  }

  const getDependencyIcon = () => {
    if (!task.is_live && blockingTasks && blockingTasks.length > 0) {
      return <AlertCircle className="w-3 h-3" />;
    }
    
    switch (task.dependency_type) {
      case 'sequential':
        return <GitBranch className="w-3 h-3" />;
      case 'parallel':
        return <Clock className="w-3 h-3" />;
      default:
        return <Link2 className="w-3 h-3" />;
    }
  };

  const getDependencyText = () => {
    if (!task.is_live && blockingTasks && blockingTasks.length > 0) {
      return `Blocked by ${blockingTasks.length} task${blockingTasks.length > 1 ? 's' : ''}`;
    }
    
    if (task.is_live) {
      return 'Dependencies met';
    }
    
    return `${task.depends_on.length} dependenc${task.depends_on.length > 1 ? 'ies' : 'y'}`;
  };

  const getStatusColor = () => {
    if (!task.is_live && blockingTasks && blockingTasks.length > 0) {
      return 'bg-red-100 text-red-700';
    }
    
    if (task.is_live) {
      return 'bg-green-100 text-green-700';
    }
    
    return 'bg-gray-100 text-gray-700';
  };

  return (
    <div className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs ${getStatusColor()}`}>
      {getDependencyIcon()}
      <span>{getDependencyText()}</span>
      {task.is_live && <CheckCircle className="w-3 h-3" />}
    </div>
  );
}

export default TaskDependencyBadge;